/**
 * The interface state is split into mutable and immutable state. Both may come pre-loaded from the server or the URL,
 * but only the mutable state should be altered during the lifetime of the app. The rest of the app relies on the
 * immutability of the immutable part of the interface state.
 * */
import {
    SET_FILTER_BAR_CONTAINER_WIDTH,
    SET_IMMUTABLE_INTERFACE_DATA,
    SET_REGISTER_TABLE_WIDTHS, SET_WIDTHS_FOR_WINDOW_RESIZE,
    TOGGLE_TABLE_HEADER_FIXED
} from "../actions/interface";

export const initialImmutableInterfaceState = {
    numTableColumns: null,  // set with pre-loaded state, never with an action
};

export function immutableInterface(state = initialImmutableInterfaceState, action) {
    switch (action.type) {
        case SET_IMMUTABLE_INTERFACE_DATA:
            return {
                ...state,
                numTableColumns: action.numTableColumns,
            };

        default:
            return state
    }
}

export const initialMutableInterfaceState = {
    tableHeaderIsFixed: false,
    registerTableWidth: "100%",
    registerTableScrollWrapperWidth: "100%",
    filterBarContainerWidth: "100%"
};

export function mutableInterface(state = initialMutableInterfaceState, action) {
    switch (action.type) {

        case TOGGLE_TABLE_HEADER_FIXED:
            return {
                ...state,
                tableHeaderIsFixed: action.tableHeaderIsFixed
            };

        case SET_REGISTER_TABLE_WIDTHS:
            return {
                ...state,
                registerTableWidth: action.registerTableWidth,
                registerTableScrollWrapperWidth: action.registerTableScrollWrapperWidth
            };

        case SET_FILTER_BAR_CONTAINER_WIDTH:
            return {
                ...state,
                filterBarContainerWidth: action.filterBarContainerWidth
            };

        case SET_WIDTHS_FOR_WINDOW_RESIZE:
            return {
                ...state,
                registerTableScrollWrapperWidth: action.registerTableScrollWrapperWidth,
                filterBarContainerWidth: action.filterBarContainerWidth
            };

        default:
            return state
    }
}